const DM_DEEP_DIVE_REPOSITORY =
  'https://mytakeda.sharepoint.com/:f:/r/sites/DMDeepDiveRepository/Shared%20Documents/DM%20Deep%20Dive%20Repository?csf=1&web=1&e=7OQiOF';
export default DM_DEEP_DIVE_REPOSITORY;
